import { Stack, Typography, useTheme } from "@mui/material";
import ButtonComponent from "../../components/form/buttonComponent";
import { useTranslation } from "react-i18next";
import { useCallback, useState } from "react";
import GetQuote from "../contactUs/getQuote";
import companyData from '../../assets/data/company.json';

const CaseStudyHero = ({
    title,
    industry,
    themeColor
}) => {
    const theme = useTheme();
    const {t} = useTranslation();

    const [openQuoteForm, setOpenQuoteForm] = useState(false);

    const getAQuote = useCallback(() => {
        // setOpenQuoteForm(true);

        window.open(companyData.contact.formLinks.quotation, "_blank");
    }, []);

    return (
        <>
            <Stack
                direction='column'
                justifyContent='center'
                alignItems='center'
                width='100%'
                sx={{
                    backgroundImage: `linear-gradient(to top, rgba(255,0,0,0) 1%, ${themeColor})`,
                    borderRadius: 4
                }}
                py={{xs: 4, md: 10}}
                spacing={{xs: 2, md: 5}}
            >
                <Stack
                    direction={{xs: 'column', lg: 'row'}}
                    justifyContent={{xs: 'center', lg: 'space-between'}}
                    alignItems='center'
                    width='100%'
                    spacing={{xs: 2, md: 10}}
                >
                    <Typography
                        fontWeight={700}
                        fontSize={{xs: 30, md: 45, lg: 60}}
                        textAlign={{xs: 'center', md: 'left'}}
                        lineHeight={1}
                        color='white'
                        letterSpacing={-1}
                        pl={{xs: 0, md: 10}}
                    >
                        {title} 
                    </Typography>

                    <Typography
                        fontWeight={500}
                        fontSize={{xs: 12, md: 12, lg: 16}}
                        textAlign={{xs: 'justify', md: 'left'}}
                        lineHeight={{xs: 1.5, md: 2}}
                        color='white'
                        pl={{xs: 3, md: 0}}
                        pr={{xs: 3, md: 10}}
                        sx={{
                            textShadow: '1px 1px 1px rgba(0, 0, 0, 0.1)'
                        }}
                    >
                        {industry}
                    </Typography>
                </Stack>

                <ButtonComponent 
                    label={t('services.interested')}
                    onClick={getAQuote}
                    sx={{
                        backgroundColor: 'white',
                        color: theme.palette.primary.main,
                        animation: 'bounceButton 1s infinite',
                        '&: hover': {
                            backgroundColor: 'white',
                            color: theme.palette.primary.main,
                        }
                    }}
                />
            </Stack>

            <GetQuote open={openQuoteForm} setOpen={setOpenQuoteForm}/>
        </>
    );
}

export default CaseStudyHero;